import { createAction, createSlice } from "@reduxjs/toolkit";

import listFactory from "../../../store/listFactory";

import type {
  CashManagementProvider,
  CashManagementProviderCurrencies,
} from "../models/Provider";

const { slicePart, selectors } = listFactory<CashManagementProvider>(
  "cashManagementProvider"
);

const initialState = {
  ...slicePart.initialState,
  currencies: [] as CashManagementProviderCurrencies[],
  configurableProviders: [] as CashManagementProvider[],
};

export const slice = createSlice({
  ...slicePart,
  initialState,
  reducers: {
    setItem: slicePart.reducers.setItem,
    setList: slicePart.reducers.setList,
    setSupportedCurrencies: (state, action) => {
      const { data } = action.payload;

      state.currencies = data;
    },
    setConfigurableProviders: (state, action) => {
      const { data } = action.payload;

      state.configurableProviders = data.list;
    },
  },
});

export const {
  setList,
  setItem,
  setSupportedCurrencies,
  setConfigurableProviders,
} = slice.actions;

export const fetchProviders = createAction("fetchProviders");

export const fetchSupportedCurrencies = createAction(
  "fetchSupportedCurrencies"
);

export const fetchConfigurableProviders = createAction(
  "fetchConfigurableProviders"
);

export const selectSupportedCurrencies = (state: any) => {
  return state.cashManagementProvider.currencies;
};

export const selectConfigurableProviders = (state: any) => {
  return state.cashManagementProvider.configurableProviders;
};

export const {
  selectList: selectProviders,
  selectItem: selectProvider,
} = selectors;

export const providerOperationPaths = () => {
  return {
    listing: ["cashManagement", "provider", "list"],
    configurableProviders: [
      "cashManagement",
      "providers",
      "configurableProviders",
    ],
  };
};

export default slice.reducer;
